import { Features, objectIdSchema } from '@hero/schema';
import { z } from 'zod';
import { API } from '../..';

/**
 * GET /features/me — resolved features for the current caller's org.
 * Returns FREE_DEFAULTS merged with subscription plan + addons + overrides.
 */
export const featuresGetMineAPISchema = z.object({}).partial();
export type FeaturesGetMineAPI = API<
  z.infer<typeof featuresGetMineAPISchema>,
  Features
>;

/** GET /features/admin — admin lookup by orgId. */
export const featuresGetAdminAPISchema = z.object({
  orgId: objectIdSchema,
});
export type FeaturesGetAdminAPI = API<
  z.infer<typeof featuresGetAdminAPISchema>,
  Features
>;
